import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @author PKr
 * @author Tomáš Leity
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { PromoSettings, DefaultWindowTypeSettings, CherryPickSettings, RoundingRulesSettings, ChangedWorkflowStateSettings, ReplenishmentSettings, ThresholdSettings } from '@logio/common-be-fe';
import { action, observable, runInAction } from 'mobx';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
import { PromoSettingsLayer } from '../../transportLayers/promo-settings/PromoSettingsLayer';
/**
 * Persistent store promo general configuration
 */

export var PromoSettingsStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(PromoSettingsStore, _BaseStore);

  function PromoSettingsStore() {
    var _this;

    _classCallCheck(this, PromoSettingsStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromoSettingsStore).apply(this, arguments));
    _this.name = StoreName.PromoSettings;
    /* Get dependent layer */

    _this.settingsLayer = new PromoSettingsLayer();
    return _this;
  }
  /**
   * Gets promo settings
   * @returns a promise with Map of all WindowTypes
   */


  _createClass(PromoSettingsStore, [{
    key: "getSettings",
    value: function getSettings() {
      var _this2 = this;

      return this.settingsLayer.getSettings().then(function (settings) {
        runInAction(function () {
          _this2.settings = settings;
        });
        return _this2.settings;
      });
    }
    /**
     * Updates promo settings
     * @param settingItem
     */

  }, {
    key: "updateSettings",
    value: function updateSettings(settingItem) {
      var _this3 = this;

      return this.settingsLayer.updateSettings(settingItem).then(function (settings) {
        runInAction(function () {
          _this3.settings = settings;
        });
        return _this3.settings;
      });
    }
    /**
     * Update default window type for promo settings
     * @param windowType
     */

  }, {
    key: "updateDefaultWindowType",
    value: function updateDefaultWindowType(windowType) {
      var settingsItem = new PromoSettings(this.settings.id, this.settings.thresholdSettings, this.settings.replenishmentSettings, windowType, this.settings.cherryPickSettings, this.settings.changedWorkflowState, this.settings.roundingRules);
      return this.updateSettings(settingsItem);
    }
    /**
     * Update cherry picking for promo settings
     * @param cherryPicking
     */

  }, {
    key: "updateCherryPicking",
    value: function updateCherryPicking(cherryPicking) {
      var settingsItem = new PromoSettings(this.settings.id, this.settings.thresholdSettings, this.settings.replenishmentSettings, this.settings.defaultWindowType, cherryPicking, this.settings.changedWorkflowState, this.settings.roundingRules);
      return this.updateSettings(settingsItem);
    }
    /**
     * Update rounding rules for promo settings
     * @param rules
     */

  }, {
    key: "updateRoundingRules",
    value: function updateRoundingRules(rules) {
      var settingsItem = new PromoSettings(this.settings.id, this.settings.thresholdSettings, this.settings.replenishmentSettings, this.settings.defaultWindowType, this.settings.cherryPickSettings, this.settings.changedWorkflowState, rules);
      return this.updateSettings(settingsItem);
    }
    /**
     * Update workflow state for promo settings
     * @param state
     */

  }, {
    key: "updateWorkflowState",
    value: function updateWorkflowState(state) {
      var settingsItem = new PromoSettings(this.settings.id, this.settings.thresholdSettings, this.settings.replenishmentSettings, this.settings.defaultWindowType, this.settings.cherryPickSettings, state, this.settings.roundingRules);
      return this.updateSettings(settingsItem);
    }
    /**
     * Update replenishment for promo settings
     * @param replenishmentSettings
     */

  }, {
    key: "updateReplenishmentSettings",
    value: function updateReplenishmentSettings(replenishmentSettings) {
      var settingsItem = new PromoSettings(this.settings.id, this.settings.thresholdSettings, replenishmentSettings, this.settings.defaultWindowType, this.settings.cherryPickSettings, this.settings.changedWorkflowState, this.settings.roundingRules);
      return this.updateSettings(settingsItem);
    }
  }, {
    key: "updateThresholdSettings",
    value: function updateThresholdSettings(thresholdSettings) {
      var settingsItem = new PromoSettings(this.settings.id, thresholdSettings, this.settings.replenishmentSettings, this.settings.defaultWindowType, this.settings.cherryPickSettings, this.settings.changedWorkflowState, this.settings.roundingRules);
      return this.updateSettings(settingsItem);
    }
  }]);

  return PromoSettingsStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", PromoSettings)], PromoSettingsStore.prototype, "settings", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], PromoSettingsStore.prototype, "getSettings", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [PromoSettings]), __metadata("design:returntype", Promise)], PromoSettingsStore.prototype, "updateSettings", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [DefaultWindowTypeSettings]), __metadata("design:returntype", Promise)], PromoSettingsStore.prototype, "updateDefaultWindowType", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [CherryPickSettings]), __metadata("design:returntype", Promise)], PromoSettingsStore.prototype, "updateCherryPicking", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [RoundingRulesSettings]), __metadata("design:returntype", Promise)], PromoSettingsStore.prototype, "updateRoundingRules", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [ChangedWorkflowStateSettings]), __metadata("design:returntype", Promise)], PromoSettingsStore.prototype, "updateWorkflowState", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [ReplenishmentSettings]), __metadata("design:returntype", void 0)], PromoSettingsStore.prototype, "updateReplenishmentSettings", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [ThresholdSettings]), __metadata("design:returntype", void 0)], PromoSettingsStore.prototype, "updateThresholdSettings", null);